import React from 'react'
import { Heading, Box, Text } from 'theme-ui'

/**
 * Shadow me to add your own content
 */

const styles = {
  wrapper: {
    ml: 3
  },
  heading: {
    color: `alpha`
  },
  running: {
    color: `omegaDark`,
    fontWeight: `body`
  }
}

export default () => (
    <Box sx={styles.wrapper}>
      <center><h2><a href="https://twitter.com/shakeshoutout">shake shoutout</a></h2>The top three domains won over the last 24 hours on the Handshake network.<br /><br />🏆 https://happiest/<br />1,800.00 HNS<br />0.00 ETH<br />$3.01<br /><br />🥈 https://usd1/<br />1,000.00 HNS<br />0.00 ETH<br />$1.67<br /><br />🥉 https://1152/<br />450.00 HNS<br />0.00 ETH<br />$0.75<br /><br /><br /><br /><br /><br /><h2><a href="https://twitter.com/nbshoutout">nb shoutout</a></h2>The top three domains bought over the last 24 hours in the Namebase marketplace.<br /><br />🏆 https://patrickcollison/<br />5,000.00 HNS<br />0.02 ETH<br />$32.51<br /><br />🥈 https://exhibitors/<br />2,700.00 HNS<br />0.01 ETH<br />$17.56<br /><br />🥉 https://exhibitor/<br />2,000.00 HNS<br />0.01 ETH<br />$13.00<br /><br /><br /><br /><br /><br /><h2><a href="https://twitter.com/shake_supply">shake supply</a></h2>The circulating HNS supply against the maximum supply.<br /><br />[ ▉▉▉▉▉▉▉▉▉▉▉▉▁▁▁▁▁ ] 70.50%<br /><br /><br /><br /><br /><br /><h2><a href="https://twitter.com/shakesplit">shake split</a></h2>The progress made toward the next Handshake halving.<br /><br />[ ▁▁▁▁▁▁▁▁▁▁▁▁▁▁▁▁▁ ] 0.6%<br /><br /><br /><br /><br /><br /><h2><a href="https://twitter.com/shakefoss">shake foss</a></h2>The claimed HNS against the total airdrop to FOSS developers. And the new and total claims since the last tweet.<br /><br />[ ▍▁▁▁▁▁▁▁▁▁▁▁▁▁▁▁▁ ] 2.91% (New: 0 Total: 6544)<br /><br /><br /><br /><br /><br /></center>
		</Box>
	)